import { render, staticRenderFns } from "./ISMSCodeDataReport.vue?vue&type=template&id=2adaf4a0"
import script from "./ISMSCodeDataReport.vue?vue&type=script&lang=js"
export * from "./ISMSCodeDataReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports